import {
    importGeoCompassDarkImage,
    importGeoCompassImage,
    importGeoCompassInvertedDarkImage,
    importGeoCompassInvertedImage,
    importGeoCompassMinusDarkImage,
    importGeoCompassMinusImage,
    importGeoCompassPlusDarkImage,
    importGeoCompassPlusImage,
    importGpsPositionMarkerImage,
    importGrassImage,
    importGrassInstance0Image,
    importGrassInstance1Image,
    importGrassInstance2Image,
    importGrassInstance3Image,
    importGrassNmImage,
    importPoiImage,
    importPointsImage,
    importSkyboxImage
} from "App/storage/dynamic_imports";

export default
class DynamicAssetsManager {

    public static assets: any = {};
    private static instance: DynamicAssetsManager = null;
    constructor() {
        //
    }

    public static loadAsset(name: string, callback: (asset: any) => void) {
        let loader: any = DynamicAssetsManager.assets[name];
        if (loader !== undefined) {
            DynamicAssetsManager.assets[name]().then(callback);
        }
        else {
            console.log("Error: Cannot find asset loader for " + name);
        }
    }

    public static init() {
        if (!DynamicAssetsManager.instance) {
            DynamicAssetsManager.instance = this;
        }

        DynamicAssetsManager.assets['@assets/images/poi_texture.png'] = importPoiImage;

        DynamicAssetsManager.assets['@assets/images/points_texture.png'] = importPointsImage;

        DynamicAssetsManager.assets['@assets/images/skybox.png'] = importSkyboxImage;

        DynamicAssetsManager.assets['@assets/images/gps_pos_marker.png'] = importGpsPositionMarkerImage;

        DynamicAssetsManager.assets['@assets/images/environment/grass.png'] = importGrassImage;

        DynamicAssetsManager.assets['@assets/images/environment/grass-nm.png'] = importGrassNmImage;

        DynamicAssetsManager.assets['@assets/images/environment/grass-instance-0.png'] = importGrassInstance0Image;

        DynamicAssetsManager.assets['@assets/images/environment/grass-instance-1.png'] = importGrassInstance1Image;

        DynamicAssetsManager.assets['@assets/images/environment/grass-instance-2.png'] = importGrassInstance2Image;

        DynamicAssetsManager.assets['@assets/images/environment/grass-instance-3.png'] = importGrassInstance3Image;

        DynamicAssetsManager.assets['@assets/images/environment/geoCompass.png'] = importGeoCompassImage;

        DynamicAssetsManager.assets['@assets/images/environment/geoCompass_dark.png'] = importGeoCompassDarkImage;

        DynamicAssetsManager.assets['@assets/images/environment/geoCompassInverted.png'] = importGeoCompassInvertedImage;
        DynamicAssetsManager.assets['@assets/images/environment/geoCompassInverted_dark.png'] = importGeoCompassInvertedDarkImage;

        DynamicAssetsManager.assets['@assets/images/environment/geoCompassMinus.png'] = importGeoCompassMinusImage;

        DynamicAssetsManager.assets['@assets/images/environment/geoCompassMinus_dark.png'] = importGeoCompassMinusDarkImage;

        DynamicAssetsManager.assets['@assets/images/environment/geoCompassPlus.png'] = importGeoCompassPlusImage;

        DynamicAssetsManager.assets['@assets/images/environment/geoCompassPlus_dark.png'] = importGeoCompassPlusDarkImage;
    }
}

DynamicAssetsManager.init();
